// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nt-1";
export var messageSideRight = "_nt-2";
export var subscribeToBackInStockBubbleContainer = "_nt-0";